import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { ArrowCarouselIcon } from '@spa/shared/svg/arrowCarousel';
import { order } from '@spa/shared/utils/order';
import {
  CarouselContainer,
  InnerCarouselContainer,
  CarouselWrapper,
  CarouselItem,
  LeftNavigator,
  RightNavigator
} from './styles.js';

export const getDisplayedIndexes = (itemsCount, active, displayedItemsCount = 5) => {
  if (itemsCount <= 1) {
    return Array.from(new Array(itemsCount), (_, index) => `${index}`);
  }

  const halfOfTheItems = Math.floor(displayedItemsCount / 2);

  if (itemsCount < 5) {
    return Array.from(
      new Array(displayedItemsCount),
      (_, index) =>
        `${Array.from(new Array(index), () => '0').join('')}${order(itemsCount, active, index - halfOfTheItems)}`
    );
  }

  return Array.from(new Array(displayedItemsCount), (_, index) => order(itemsCount, active, index - halfOfTheItems));
};

const Carousel = ({ carouselRef, handleBack, handleNext, style, handlers, showNavigators = false, children }) => {
  return (
    <CarouselContainer ref={carouselRef} style={style.container} tabIndex="0">
      <InnerCarouselContainer>
        <CarouselWrapper style={style.carousel} {...handlers} tabIndex="-1">
          {children}
        </CarouselWrapper>
      </InnerCarouselContainer>
      {showNavigators ? (
        <Fragment>
          <LeftNavigator navigatorPos={style.navigatorPos} onClick={handleBack}>
            <ArrowCarouselIcon />
          </LeftNavigator>
          <RightNavigator navigatorPos={style.navigatorPos} onClick={handleNext}>
            <ArrowCarouselIcon />
          </RightNavigator>
        </Fragment>
      ) : null}
    </CarouselContainer>
  );
};

export const Item = ({ style, width, children }) => {
  return (
    <CarouselItem width={width} style={style}>
      {children}
    </CarouselItem>
  );
};

Item.propTypes = {
  style: PropTypes.object.isRequired,
  width: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)])
};

Carousel.propTypes = {
  carouselRef: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  handleBack: PropTypes.func,
  handleNext: PropTypes.func,
  showNavigators: PropTypes.bool,
  style: PropTypes.object.isRequired,
  handlers: PropTypes.object
};

export default Carousel;
